<template>
  <div style="position:relative;">
    <div class="civii-top-menu">
      <div class="civii-top-menu-bubble">
        <div class="civii-icon-bot civii-top-menu-bubble-icon"></div>
        <div class="civii-top-menu-bubble-text" v-if="workspace == 'servicios_digitales.v2' ">CIVii - Asistente virtual</div>
        <div class="civii-top-menu-bubble-text" v-else>CIVii</div>
      </div>
      <div class="civii-top-menu-options">
        <i @click="resetChat" class="civii-icon-eraser" :title="eraser"></i>
        <i @click="toggleSound" :class="['civii-icon-' + (sound ? 'volume-up' : 'volume-off')]" :title="(sound ? volumeUp : volumeOff)"></i>
        <i v-if="menuView" @click="menuOpen=!menuOpen" class="civii-icon-menu-three"></i>
      </div>
    </div>
    <div @click="menuOpen=false" v-show="menuOpen" :class="[
      'civii-menu-items-back' + (civiiConf.full_size?'-full':'')]" ></div>
    <div v-show="menuOpen" id="civii-menu-items" class="civii-menu-items">
      <div v-for="(tema, index) in civiiConf.menuItems" :key="'menu'+index">
        <div class="civii-menu-items-title"
          @click="temaSelected = index; itemsLowerLimit = 0">
          <i class="civii-icon-arrow-right civii-tick"
            :class="{opened: temaSelected === index}" />
          {{tema.title}}
        </div>
        <div v-show="temaSelected === index"
          class="civii-menu-items-container"
          :class="{opened: temaSelected === index}"
          v-on:wheel="itemsScrolled">
          <div class="civii-arrow"
            :class="{disabled: itemsLowerLimit === 0}"
            @click="itemsGoUp">&#9652;</div>
          <div v-for="(item, innerIndex) in tema.messages"
            v-show="innerIndex <= itemsUpperLimit && innerIndex >= itemsLowerLimit"
            :key="'menuItem'+innerIndex" class="civii-menu-items-item"
            @click="sendMessage(item);menuOpen=false">
            {{item}}
          </div>
          <div class="civii-arrow"
            :class="{disabled: itemsUpperLimit === civiiConf.menuItems[index].messages.length - 1}"
            @click="itemsGoDown">&#9662;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data () {
    return {
      menuOpen: false,
      temaSelected: 0,
      itemsLowerLimit: 0,
      civiiConf: window.civiiConf,
      volumeUp: civiiConf.titleButtonVolumenUp,
      volumeOff: civiiConf.tittleButtonVolumenOff,
      eraser: civiiConf.titleButtonEraser,
      workspace: civiiConf.workspace
    }
  },
  computed: {
    menuView () {
      try {
        return JSON.parse(sessionStorage.getItem('contextoApps')).loggeado
      } catch (e) {
        return false;
      }
      
    },
    sound () {
      return this.$store.state.sound
    },
    itemsUpperLimit () {
      if (this.civiiConf.menuItems[this.temaSelected].messages.length < 4) {
        return this.itemsLowerLimit + this.civiiConf.menuItems[this.temaSelected].messages.length - 1
      } else {
        return this.itemsLowerLimit + 3
      }
    }
  },
  methods: {
      ...mapActions('civiiChat', ['closeConnection']),
    resetChat () {
        this.closeConnection();
        window.civii.restart();
    },
    async sendMessage (message) {
      await this.$store.dispatch('sendMessage', {message})
    },
    toggleSound () {
      this.$store.commit('toggleSound')
    },
    itemsGoDown () {
      if (this.itemsUpperLimit < this.civiiConf.menuItems[this.temaSelected].messages.length - 1) {
        this.itemsLowerLimit++
      }
    },
    itemsGoUp () {
      if (this.itemsLowerLimit > 0) {
        this.itemsLowerLimit--
      }
    },
    itemsScrolled (e) {
      if (e.deltaY < 0) {
        this.itemsGoUp()
      }
      if (e.deltaY > 0) {
        this.itemsGoDown()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TopMenu/TopMenu.vue